// Área "Discadora" — integração CRM → discadora (03/11/2026; contas desde 04/11, resposta do Eduardo).
// 9175 = teste legado (BotConversa, painel, cliente 19). 151 = Goodata (cliente 20, só chave de integração).
// O serviço discadora-crm (/api/discadora/*) repete a mesma lista de contas (DISC_CONTAS) e recusa as outras.
export const DISCADORA_GRUPOS = ["9175", "151"];

// A 151 é uma conta em uso por outros times (Passeios, Gráfica): a área fica só com o usuário
// "[BR] Goodata" (cliente_usuario 20) enquanto é teste.
export const DISCADORA_USUARIOS: Record<string, string[]> = { "151": ["20"] };

// Botão "Ligar" no card do Kanban: só contas com chave de integração. Mesmo nelas, ele só aparece para
// quem tem um atendente da discadora ligado ao seu usuário (configurado na área Discadora).
export const DISCADORA_LIGAR_GRUPOS = ["151"];

export const canViewDiscadora = (): boolean => {
  const g = localStorage.getItem("id_grupo") || "";
  if (!DISCADORA_GRUPOS.includes(g)) return false;
  const lista = DISCADORA_USUARIOS[g];
  return !lista || lista.includes(localStorage.getItem("id_user") || "");
};
